(function () {
  if (window.__nvProduct) return;
  window.__nvProduct = true;

  // Shop money format, e.g. "{{amount}} ₪". Prices arrive in agorot.
  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}} ₪';
    var value = cents / 100;
    return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toLocaleString('de-DE');
        default: return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    });
  }

  function wireDialog(dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-nvp-close]')) dialog.close();
    });
  }

  // Runs `callback` once `element` comes within `margin` of the viewport.
  function whenNear(element, margin, callback) {
    if (!('IntersectionObserver' in window)) { callback(); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      callback();
    }, { rootMargin: margin });
    observer.observe(element);
  }

  function initProduct(box) {
    if (box.__ready) return;
    box.__ready = true;

    var variants = JSON.parse(box.querySelector('[data-nvp-json]').textContent);
    var radios = Array.prototype.slice.call(box.querySelectorAll('[data-nvp-option]'));
    var idInput = box.querySelector('[data-nvp-id]');
    var addButtons = box.querySelectorAll('[data-nvp-add]');
    var track = box.querySelector('[data-nvp-track]');
    var countEl = box.querySelector('[data-nvp-index]');
    var info = box.querySelector('.nvp-info');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 990px)');
    var labels = { add: box.dataset.labelAdd, soldout: box.dataset.labelSoldout, unavailable: box.dataset.labelUnavailable };

    function selected() {
      var values = [];
      radios.forEach(function (radio) { if (radio.checked) values[Number(radio.dataset.nvpOption)] = radio.value; });
      return values;
    }

    // A value is in stock when some available variant has it together with the
    // values already chosen in the options before it (colour first, then size).
    function markAvailability(values) {
      radios.forEach(function (radio) {
        var index = Number(radio.dataset.nvpOption);
        var ok = variants.some(function (variant) {
          if (!variant.available || variant.options[index] !== radio.value) return false;
          for (var i = 0; i < index; i++) if (variant.options[i] !== values[i]) return false;
          return true;
        });
        var label = radio.closest('.nvp-value');
        label.classList.toggle('is-unavailable', !ok);
        var note = label.querySelector('[data-nvp-sr]');
        if (note) note.textContent = ok ? '' : ' – אזל מהמלאי';
      });
    }

    function setButtons(variant) {
      var text = !variant ? labels.unavailable : (variant.available ? labels.add : labels.soldout);
      addButtons.forEach(function (button) {
        button.disabled = !variant || !variant.available;
        var span = button.querySelector('span');
        if (span) span.textContent = text;
      });
    }

    function setPrice(variant) {
      box.querySelectorAll('[data-nvp-now]').forEach(function (el) { el.textContent = money(variant.price); });
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      box.querySelectorAll('[data-nvp-was]').forEach(function (el) { el.hidden = !onSale; });
      if (onSale) box.querySelectorAll('[data-nvp-compare]').forEach(function (el) { el.textContent = money(variant.compare_at_price); });
    }

    function updateCount() {
      if (!countEl || !track) return;
      var width = track.clientWidth || 1;
      countEl.textContent = String(Math.round(Math.abs(track.scrollLeft) / width) + 1);
    }

    // Bring the chosen colour's photo to the front of the gallery.
    function showMedia(variant) {
      if (!variant.featured_media || !track) return;
      var item = track.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (!item || item === track.firstElementChild) return;
      track.insertBefore(item, track.firstElementChild);
      var behavior = reduce.matches ? 'auto' : 'smooth';
      if (desktop.matches) {
        var top = track.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 120, behavior: behavior });
      } else {
        track.scrollTo({ left: 0, behavior: behavior });
      }
      updateCount();
      var thumb = box.querySelector('[data-nvp-sticky-img]');
      var img = item.querySelector('img');
      if (thumb && img) thumb.src = img.currentSrc || img.src;
    }

    function update(fromUser) {
      var values = selected();
      box.querySelectorAll('[data-nvp-label]').forEach(function (el) {
        el.textContent = values[Number(el.dataset.nvpLabel)] || '';
      });
      markAvailability(values);
      var variant = variants.find(function (v) {
        return v.options.every(function (value, index) { return value === values[index]; });
      });
      setButtons(variant);
      if (!variant) return;
      idInput.value = variant.id;
      setPrice(variant);
      if (fromUser) {
        showMedia(variant);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    radios.forEach(function (radio) { radio.addEventListener('change', function () { update(true); }); });
    update(false);
    if (track) track.addEventListener('scroll', updateCount, { passive: true });

    // Desktop: the details column sticks below the header, or, when it is
    // taller than the window, by its bottom edge so every part stays reachable.
    function setStickyTop() {
      if (!info) return;
      var header = document.querySelector('sticky-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var top = Math.min(headerHeight + 20, window.innerHeight - info.offsetHeight - 24);
      box.style.setProperty('--nvp-top', top + 'px');
    }
    setStickyTop();
    window.addEventListener('resize', setStickyTop);
    if ('ResizeObserver' in window && info) new ResizeObserver(setStickyTop).observe(info);

    // Full-screen photos.
    var light = box.querySelector('[data-nvp-light]');
    var lightList = box.querySelector('[data-nvp-light-list]');
    if (light) {
      wireDialog(light);
      box.addEventListener('click', function (event) {
        var zoom = event.target.closest('[data-nvp-zoom]');
        if (!zoom) return;
        var id = zoom.closest('[data-media-id]').dataset.mediaId;
        light.showModal();
        var target = light.querySelector('[data-light-id="' + id + '"]');
        if (target && lightList) lightList.scrollTop = target.offsetTop - 8;
      });
    }

    // Size chart.
    var sizeSheet = box.querySelector('[data-nvp-size-sheet]');
    if (sizeSheet) {
      wireDialog(sizeSheet);
      box.querySelectorAll('[data-nvp-open-size]').forEach(function (button) {
        button.addEventListener('click', function () { sizeSheet.showModal(); });
      });
    }

    // Phone sticky bar: shown once the main button has scrolled away above.
    var sticky = box.querySelector('[data-nvp-sticky]');
    var mainButton = box.querySelector('[data-nvp-main-add]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.inert = !show;
      }).observe(mainButton);
    }
  }

  // "You may also like": Shopify recommendations, fetched as a section once the
  // shopper is about a screen away, so the cards are ready when they arrive.
  function initRecommendations(box) {
    if (box.__ready || !box.dataset.url) return;
    box.__ready = true;
    var section = box.closest('[data-nvr-section]');
    function hide() { if (section) section.hidden = true; }
    whenNear(box, '800px 0px', function () {
      fetch(box.dataset.url)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-nvr]');
          if (!fresh || !fresh.querySelector('.nvc-card')) { hide(); return; }
          box.innerHTML = fresh.innerHTML;
          box.removeAttribute('aria-busy');
        })
        .catch(hide);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nvp]').forEach(initProduct);
    (root || document).querySelectorAll('[data-nvr]').forEach(initRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
